import Vue from 'vue'

const state = {
  imagesChecked: {

  },
  uploadedPicturesArray: [],
  isSelectingImages: false
}

const mutations = {

  RESET_ALL_IMAGES_CHECKED: (state) => {
    console.log('Inside RESET_IMAGES_CHECKED')
    state.imagesChecked = {}
  },
  SET_IMAGES_CHECKED: (state, payload) => {
    const key = payload.key
    const images = payload.images
    console.log('Inside SET_IMAGES_CHECKED', payload)
    // Utilise Vue.set pour forcer la réactivité
    Vue.set(state.imagesChecked, key, images)
  },
  SET_IS_SELECTING_IMAGES: (state, value) => {
    console.log('Inside SET_IS_SELECTING_IMAGES', value)
    state.isSelectingImages = value
  },
  SET_UPLOADED_PICTURES_ARRAY: (state, images) => {
    console.log('Inside SET_UPLOADED_PICTURES_ARRAY', images)
    state.uploadedPicturesArray = images
  },
  RESET_IMAGES_CHECKED: (state, key) => {
    console.log('Inside RESET_IMAGES_CHECKED', key)
    Vue.set(state.imagesChecked, key, [])
  }

}

const getters = {
  GET_IMAGES_CHECKED: (state) => state.imagesChecked,
  GET_IS_SELECTING_IMAGES: (state) => state.isSelectingImages,
  GET_UPLOADED_PICTURES_ARRAY: (state) => state.uploadedPicturesArray
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
